import React from 'react';

function OperationalSummaryGrid({ className = '', items = [] }) {
  return (
    <div className={`summary-grid ${className}`.trim()}>
      {items.map((item) => {
        const {
          description = '',
          isLink = false,
          key,
          label = '',
          onClick,
          title,
          value = ''
        } = item;

        if (isLink) {
          return (
            <div
              key={key}
              className="summary-card role-summary-card-link"
              role="button"
              tabIndex={0}
              title={title || label}
              onClick={onClick}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  onClick?.();
                }
              }}
            >
              <span className="summary-card-label">{label}</span>
              <strong>{value}</strong>
              <p>{description}</p>
            </div>
          );
        }

        return (
          <div key={key} className="summary-card">
            <span className="summary-card-label">{label}</span>
            <strong>{value}</strong>
            <p>{description}</p>
          </div>
        );
      })}
    </div>
  );
}

export default OperationalSummaryGrid;
